import React from 'react';
import { motion } from 'framer-motion';
import service1 from "../../images/service1.png";
import service2 from "../../images/service2.png";
import service3 from "../../images/service3.png";
import service4 from "../../images/service4.png";

const servicesData = [
  {
    title: "Carbon Tracking",
    description: "CloseCarbon's Carbon Tracking feature enables individuals and organizations to monitor their emissions in real time through IoT-enabled data capture and intelligent analytics. Users gain a clear, data-driven understanding of their carbon footprint and performance over time.",
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="8" fill="#E7F6EC" />
        <path d="M12.75 11.625C12.75 11.3266 12.6315 11.0405 12.4205 10.8295C12.2095 10.6185 11.9234 10.5 11.625 10.5C11.3266 10.5 11.0405 10.6185 10.8295 10.8295C10.6185 11.0405 10.5 11.3266 10.5 11.625V31.875C10.5 33.3668 11.0926 34.7976 12.1475 35.8525C13.2024 36.9074 14.6332 37.5 16.125 37.5H36.375C36.6734 37.5 36.9595 37.3815 37.1705 37.1705C37.3815 36.9595 37.5 36.6734 37.5 36.375C37.5 36.0766 37.3815 35.7905 37.1705 35.5795C36.9595 35.3685 36.6734 35.25 36.375 35.25H16.125C15.2299 35.25 14.3714 34.8944 13.7385 34.2615C13.1056 33.6286 12.75 32.7701 12.75 31.875V11.625ZM28.5 16.125C28.5 16.4234 28.6185 16.7095 28.8295 16.9205C29.0405 17.1315 29.3266 17.25 29.625 17.25H33.6593L26.25 24.6593L22.5465 20.9535C22.442 20.8487 22.3179 20.7656 22.1812 20.7089C22.0445 20.6522 21.898 20.623 21.75 20.623C21.602 20.623 21.4555 20.6522 21.3188 20.7089C21.1821 20.7656 21.058 20.8487 20.9535 20.9535L15.3285 26.5785C15.2239 26.6831 15.1409 26.8073 15.0843 26.9439C15.0277 27.0806 14.9986 27.2271 14.9986 27.375C14.9986 27.5229 15.0277 27.6694 15.0843 27.8061C15.1409 27.9427 15.2239 28.0669 15.3285 28.1715C15.4331 28.2761 15.5573 28.3591 15.6939 28.4157C15.8306 28.4723 15.9771 28.5014 16.125 28.5014C16.2729 28.5014 16.4194 28.4723 16.5561 28.4157C16.6927 28.3591 16.8169 28.2761 16.9215 28.1715L21.75 23.3407L25.4535 27.0465C25.558 27.1513 25.6821 27.2344 25.8188 27.2911C25.9555 27.3478 26.102 27.377 26.25 27.377C26.398 27.377 26.5445 27.3478 26.6812 27.2911C26.8179 27.2344 26.942 27.1513 27.0465 27.0465L35.25 18.8407V23.0483C35.25 23.3466 35.3685 23.6328 35.5795 23.8437C35.7905 24.0547 36.0766 24.1732 36.375 24.1732C36.6734 24.1732 36.9595 24.0547 37.1705 23.8437C37.3815 23.6328 37.5 23.3466 37.5 23.0483V16.125C37.5 15.8266 37.3815 15.5405 37.1705 15.3295C36.9595 15.1185 36.6734 15 36.375 15H29.625C29.3266 15 29.0405 15.1185 28.8295 15.3295C28.6185 15.5405 28.5 15.8266 28.5 16.125Z" fill="#0D924F" />
      </svg>
    ),
    features: ["Real-Time Monitoring", "Source-Level Emissions Breakdown", "Baseline Establishment", "Progress Tracking & Performance Dashboards", "Reduction Goal Setting", "Intuitive User-Friendly Interface"],
    image: service1
  },
  {
    title: "Carbon Incentives (CCRTs)",
    description: "CloseCarbon Reduction Tonnes (CCRTs) are issued to projects that successfully pass validation and data verification. For every 1 metric tonne of CO₂ or CO₂e reduced, one (1) CCRT is generated. This system transforms verified emission reductions into traceable, blockchain-backed digital assets rewarding measurable climate action.",
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="8" fill="#E7F6EC" />
        <path d="M32.9961 22C31.4961 19 32.4961 20 30.6953 17.3285C29.9198 16.574 29.5328 16.1975 28.6763 15.8495C27.8198 15.5 27.0833 15.5 25.6118 15.5H22.3778C20.9063 15.5 20.1698 15.5 19.3133 15.8495C18.4583 16.1975 18.0683 16.574 17.2943 17.3285C13.752 20.8226 11.4024 25.3453 10.5803 30.2525C9.8498 34.6595 15.4541 38.5 19.9961 38.5" stroke="#0D924F" strokeWidth="2.25" strokeLinecap="round" />
        <path d="M16.8858 11.6645C16.5753 11.2145 16.1268 10.6025 17.0538 10.4645C18.0063 10.3205 18.9948 10.9715 19.9638 10.9595C20.8383 10.946 21.2838 10.5575 21.7638 10.0025C22.2678 9.419 23.0478 8 24.0003 8C24.9528 8 25.7328 9.419 26.2368 10.0025C26.7168 10.5575 27.1623 10.9475 28.0368 10.958C29.0058 10.973 29.9943 10.3205 30.9468 10.463C31.8738 10.6025 31.4253 11.213 31.1148 11.663L29.7168 13.7015C29.1168 14.5715 28.8183 15.0065 28.1913 15.254C27.5643 15.5015 26.7558 15.5 25.1373 15.5H22.8633C21.2433 15.5 20.4348 15.5 19.8093 15.254C19.1838 15.008 18.8838 14.57 18.2838 13.7L16.8858 11.6645Z" stroke="#0D924F" strokeWidth="2.25" />
        <path d="M31.7578 31.5689C29.6823 33.0783 26.274 36.005 23.8379 40.6892M26.3505 36.6215C21.497 29.8862 29.3752 26.5256 35.4177 25.501C36.1474 25.3767 36.5109 25.3154 36.8015 25.4935C37.0904 25.6705 37.1115 25.9746 37.1563 26.5788C37.5248 31.6077 35.6552 38.7321 26.3505 36.6215Z" stroke="#0D924F" strokeWidth="2.40006" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    features: ["Verified Carbon Reduction Issuance", "Transparent Blockchain Based Credit System", "Performance-Based Incentive Structure", "Motivational Rewards for Sustained Impact", "Flexible Participation for Individuals & Organizations", "Reduction Goal Alignments"],
    image: service2
  },
  {
    title: "Carbon Monitoring (Organizational Service)",
    description: "This service is designed for organisations that only want to quantify and monitor their carbon emissions. It involves identifying their emission sources, establishing baselines, tracking, quantifying their emissions and reporting it on the CloseCarbon platform.",
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="8" fill="#E7F6EC" />
        <path d="M37.5 24V30.75H10.5V12.75H18.375V10.5H10.5C9.90326 10.5 9.33097 10.7371 8.90901 11.159C8.48705 11.581 8.25 12.1533 8.25 12.75V30.75C8.25 31.3467 8.48705 31.919 8.90901 32.341C9.33097 32.7629 9.90326 33 10.5 33H19.5V37.5H15V39.75H33V37.5H28.5V33H37.5C38.0967 33 38.669 32.7629 39.091 32.341C39.5129 31.919 39.75 31.3467 39.75 30.75V24H37.5ZM26.25 37.5H21.75V33H26.25V37.5Z" fill="#0D924F" />
        <path d="M26.25 26.2501H26.2387C25.9963 26.2476 25.7612 26.1668 25.5685 26.0199C25.3757 25.8729 25.2355 25.6676 25.1689 25.4345L23.1518 18.3751H18.375V16.1251H24C24.2445 16.125 24.4824 16.2045 24.6777 16.3517C24.873 16.4989 25.015 16.7057 25.0822 16.9408L26.2905 21.1707L29.6756 10.1682C29.7481 9.93956 29.891 9.73967 30.084 9.5972C30.277 9.45473 30.5101 9.37699 30.75 9.37512C30.987 9.37156 31.2189 9.44449 31.4112 9.58311C31.6035 9.72172 31.746 9.91863 31.8176 10.1446L33.81 16.1251H39.75V18.3751H33C32.7638 18.3752 32.5336 18.3009 32.3419 18.1628C32.1503 18.0247 32.007 17.8297 31.9324 17.6056L30.7928 14.1856L27.3255 25.4559C27.2548 25.6859 27.1121 25.8871 26.9185 26.0301C26.725 26.1731 26.4906 26.2502 26.25 26.2501Z" fill="#0D924F" />
      </svg>
    ),
    features: ["Emission Source Identification", "Third-Party Verification Options", "Baseline Development", "Data Transparency & Accuracy Assurance", "Structured Quantification & Reporting", "Compliance-Ready Documentation"],
    image: service3
  },
  {
    title: "Validation & Verification",
    description: "CloseCarbon ensures credibility through independent validation and verification processes. Projects undergo structured assessments of their design, implementation, and monitoring systems to meet recognized carbon crediting standards. Verification confirms the accuracy of emissions data and the integrity of generated carbon incentives ensuring trust across stakeholders.",
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="8" fill="#E7F6EC" />
        <path d="M22.3105 29.3948L31.7353 19.97L30.3781 18.6147L22.3105 26.6822L18.2463 22.6161L16.8891 23.9734L22.3105 29.3948ZM24.3065 40.9943C20.4882 39.8613 17.3155 37.5485 14.7886 34.0559C12.2616 30.5633 10.9987 26.6284 11 22.2511V11.9709L24.3065 7L37.613 11.9709V22.2511C37.613 26.6284 36.3501 30.5633 33.8244 34.0559C31.2987 37.5485 28.1261 39.8632 24.3065 41M24.3065 38.9812C27.6014 37.9357 30.3261 35.8447 32.4805 32.7082C34.6349 29.5716 35.7121 26.0866 35.7121 22.253V13.2693L24.3065 9.03019L12.9009 13.2693V22.2511C12.9009 26.0847 13.9781 29.5697 16.1325 32.7063C18.2869 35.8428 21.0116 37.9357 24.3065 38.9812Z" fill="#0D924F" />
      </svg>
    ),
    features: ["Independent Validation Process ", "Third-Party Verification", "Data Integrity Assurance","Methodology-Based Assessment ","Meticulous Monitoring Reviews ","Enhanced Credibility & Transparency"],
    image: service4
  }
];

const OurService = ({ id }) => {
  const renderIcon = (icon) => {
    if (!icon) return null;
    if (Array.isArray(icon)) {
      return icon.map((ic, i) => {
        if (React.isValidElement(ic)) return <div key={i}>{ic}</div>;
        if (typeof ic === 'function') {
          const IconComp = ic;
          return (
            <div key={i}>
              <IconComp />
            </div>
          );
        }
        return <div key={i} />;
      });
    }

    if (React.isValidElement(icon)) return icon;
    if (typeof icon === 'function') {
      const Icon = icon;
      return <Icon />;
    }
    return null;
  };

  // Animation variants
  const slideInLeft = {
    hidden: { opacity: 0, x: -200 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: "easeOut" } }
  };

  const slideInRight = {
    hidden: { opacity: 0, x: 200 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: "easeOut" } }
  };

  const slideInLeftAlt = {
    hidden: { opacity: 0, x: -200 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: "easeOut" } }
  };

  const slideInRightAlt = {
    hidden: { opacity: 0, x: 200 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: "easeOut" } }
  };

  return (
    <section id={id} className="w-full flex flex-col items-center py-24 bg-[#FAFAFA] overflow-x-hidden">
      {/* Tag with fade-in animation */}
      <motion.div 
        className="bg-[#F0F2F5] backdrop-blur-[12.5px] rounded-[32px] px-6 py-4 mb-12"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <h5 className="text-[#0D924F] font-medium text-2xl">OUR SERVICES</h5>
      </motion.div>

      <div className="max-w-[1200px] flex flex-col gap-24">
        {servicesData.map((service, index) => {
          const isEven = index % 2 === 0;
          return (
            <div key={index} className={`flex flex-col lg:flex-row items-center justify-between gap-16 ${!isEven ? 'lg:flex-row-reverse' : ''}`}>
              
              {/* Content - slides in from left on even, right on odd */}
              <motion.div 
                className="flex-1 w-full flex flex-col gap-6"
                variants={isEven ? slideInLeft : slideInRightAlt}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
              >
                <div className="w-12 h-12 bg-[#E7F6EC] rounded-lg flex items-center justify-center">
                  {renderIcon(service.icon)}
                </div>
                <h2 className="text-[#0D924F] text-[36px] font-bold leading-[43px]">{service.title}</h2>
                <p className="text-[#898989] text-[18px] leading-[150%]">{service.description}</p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                  {service.features.map((feat, i) => (
                    <div key={i} className="flex items-center gap-4 ">
      <div className='max-w-20'>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6892_20674)">
<circle cx="10" cy="10" r="10" fill="#E7F6EC"/>
<path d="M10 4C6.68631 4 4 6.68631 4 10C4 13.3139 6.68631 16 10 16C13.3139 16 16 13.3139 16 10C16 6.68631 13.3139 4 10 4ZM10 15.2618C7.10519 15.2618 4.75 12.8948 4.75 9.99998C4.75 7.10516 7.10519 4.74998 10 4.74998C12.8948 4.74998 15.25 7.10518 15.25 9.99998C15.25 12.8948 12.8948 15.2618 10 15.2618ZM12.3946 7.80456L8.87424 11.347L7.28893 9.76169C7.14249 9.61525 6.90511 9.61525 6.75849 9.76169C6.61205 9.90812 6.61205 10.1455 6.75849 10.2919L8.61455 12.1482C8.76099 12.2944 8.99836 12.2944 9.14499 12.1482C9.16186 12.1313 9.17631 12.1129 9.18944 12.0938L12.9252 8.33499C13.0714 8.18855 13.0714 7.95118 12.9252 7.80456C12.7786 7.65813 12.5412 7.65813 12.3946 7.80456Z" fill="#099137" stroke="#099137" stroke-width="0.18"/>
</g>
<defs>
<clipPath id="clip0_6892_20674">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
        </div>

                      <span className="text-[#645D5D] text-[18px] font-medium">{feat}</span>
                    </div>
                  ))}
                </div>
              </motion.div>

              {/* Image - slides in from right on even, left on odd (opposite of content) */}
              <motion.div 
                className="flex-1 w-full"
                variants={isEven ? slideInRight : slideInLeftAlt}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
              >
                <img 
                  src={service.image} 
                  alt={service.title} 
                  className="w-[576px] h-[384px] bg-gray-200 rounded-[12px] shadow-lg object-cover" 
                />
              </motion.div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default OurService;